import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

const AGREEMENT = `I, the Customer, certify that the Installers/Independent Contractors
or their sub-contractors, have furnished all Goods and/or services, that installation,
repairs and alterations or improvements ('the installation services') have been completed
as set forth in my/our contract with Lowe's, and that I have been offered the opportunity
to request that Lowe's allow me to retain some or all of any unused, receipted surplus
materials rather than have such surplus materials remain the property of Lowe's.`;

class InstallationCompletion extends Resetter(Validator(React.Component)) {
  state = {
    customerName: this.props.customerName || '',
    errors: {},
  };

  static VALIDATIONS = {
    customerName: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      customerName: this.state.customerName,
      tab: 2,
    });
  }

  handleNameChange = (e) => {
    this.setState({ customerName: e.target.value });
  }

  render() {
    const { customerName, errors } = this.state;

    return (
      <div>
        <h6 className={S.signatureTitle}>Part 1 - Completion of Installation</h6>
        <p className={S.signatureText}>{AGREEMENT}</p>
        <SimpleInput
          required
          label="Print Customer's Name *"
          text={customerName}
          errors={errors.customerName}
          onChange={this.handleNameChange}
        />
        <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      </div>
    );
  }
}

InstallationCompletion.propTypes = {
  copyPhase: PropTypes.func,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    customerName: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(InstallationCompletion);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/installation_completion.jsx